import React from "react";
import "../styles/work.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import nammaseva from "../assets/nammaseva.png";
import dalmia from "../assets/hippostores.png";
import ems from "../assets/ems.png";
import aboutGif from "../assets/about.gif";

export default function MyWorks() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: window.innerWidth < 600 ? 1 : 2,
  };
  return (
    <div
      className="workWrapper"
      style={{
        background: `url(${aboutGif}) no-repeat`,
      }}
    >
      <div data-aos="fade-right" className="title">
        Projects
      </div>
      <div
        style={{ height: 200, width: "80%", margin: "0px auto" }}
        data-aos="zoom-in"
      >
        <Slider {...settings}>
          <div
            style={{
              padding: 10,
              margin: 10,
            }}
          >
            <a
              href="https://nammasevatrust.com/"
              rel="noreferrer"
              target="_blank"
            >
              <img src={nammaseva} alt="broken" height="400px" width="100%" />
            </a>
          </div>
          <div>
            <a
              href="https://www.hippostores.com/"
              rel="noreferrer"
              target="_blank"
            >
              <img src={dalmia} alt="broken" height="400px" width="100%" />
            </a>
          </div>{" "}
          <div>
            <img src={ems} alt="broken" height="400px" width="100%" />
          </div>
        </Slider>
      </div>
    </div>
  );
}
